import { DirectoryPageContainer } from '@/components/Directory';
import { DirectoryList } from '@/components/Directory/components/DirectoryList';
import type { CompanySeoRecord } from '@/utils/seo/company-directory';

type Props = {
  companies: CompanySeoRecord[];
  hasNextPage: boolean;
  page: number;
  totalPages?: number;
};

export function CompaniesDirectoryView({ companies, hasNextPage, page, totalPages }: Props) {
  return (
    <DirectoryPageContainer>
      <DirectoryList
        companies={companies}
        hasNextPage={hasNextPage}
        page={page}
        totalPages={totalPages}
      />
    </DirectoryPageContainer>
  );
}
